module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/team/chris-jelinek-f8b5d0694891dcb416da635f9e61b1d0.jpg";